<template>
  <div>
    <b-container class="engagement-design-page">
      <b-row>
        <!-- DESIGN PREVIEW START -->
        <b-col id="design-preview" lg="8">
          <b-row class="canvas-header pb-4 pb-lg-0">
            <b-col cols="1" class="d-flex text-center align-items-center">
              <router-link :to="{ name: 'engagementNewsPopUp' }" class="mx-auto">
                <img
                  src="@/assets/images/icons/left-arrow.svg"
                  alt="Left Arrow"
                />
              </router-link>
            </b-col>
            <b-col class="border-left">
              <div class="design-name text-truncate">
                <img
                  id="mobile-icon"
                  src="@/assets/images/mechanics/mobile.svg"
                  alt="Mobile Phone"
                />
                <span>News</span>
              </div>
            </b-col>
            <b-col class="d-flex align-items-center justify-content-end">
              <b-button
                variant="primary"
                class="btn-pill border-primary bg-white text-primary custom-btn"
                @click="saveNews"
                :disabled="isLoading"
              >
                Draft
              </b-button>
              <b-button
                variant="primary"
                class="float-right custom-btn ml-3"
                v-b-modal="'save-news-modal'"
                :disabled="isLoading"
              >
                Save
              </b-button>
            </b-col>
          </b-row>
          <!-- CANVAS START -->
          <b-row>
            <b-col id="canvas-background">
              <b-row class="mt-4 mr-4">
                <b-col class="text-right">
                  <span class="mr-3">Guides</span>
                  <switches
                    v-model="showGuides"
                    theme="custom"
                    color="primary"
                  ></switches>
                </b-col>
              </b-row>
              <!-- MOBILE CANVAS START -->
              <b-row>
                <!-- MOBILE NEWS CANVAS START -->
                <b-col>
                  <center>
                    <div class="mobile-news-canvas">
                      <div class="background-display">
                        <b-container>
                          <b-row>
                            <b-col class="d-flex px-0">
                              <div class="news-image-placeholder border-0">
                                <b-img
                                  v-if="newsImage"
                                  :src="newsImage"
                                  fluid
                                />
                              </div>
                              <span
                                class="guide-letter"
                                v-show="showGuides"
                                style="
                                  position: absolute;
                                  left: 10px;
                                  top: 15px;
                                "
                              >
                                A
                              </span>
                            </b-col>
                          </b-row>
                          <b-row v-if="newsForm.title" class="mt-3">
                            <b-col class="header-label text-left">
                              {{ newsForm.title }}
                            </b-col>
                          </b-row>
                          <b-row
                            v-if="newsForm.content"
                            class="mt-3 position-relative"
                          >
                            <span
                              class="guide-letter"
                              v-show="showGuides"
                              style="position: absolute; left: 10px; top: -10px"
                            >
                              B
                            </span>
                            <b-col class="px-0">
                              <div
                                v-html="newsForm.content"
                                class="ql-editor"
                              ></div>
                            </b-col>
                          </b-row>
                          <div
                            v-if="
                              newsForm.show_button && newsForm.buttons.length
                            "
                            class="mt-3"
                          >
                            <button
                              block
                              class="btn btn-pill mb-2 w-100"
                              v-for="(button, index) in newsForm.buttons"
                              :key="index"
                              :style="`background-color: ${newsForm.buttons.length > 0 ? newsForm.buttons[0].color : null}; color: ${newsForm.buttons.length > 0 ? newsForm.buttons[0].text_color : null}`"
                            >
                              {{ button.name }}
                            </button>
                          </div>
                        </b-container>
                      </div>
                    </div>
                  </center>
                </b-col>
                <!-- MOBILE NEWS CANVAS END -->
                <!-- MOBILE POPUP CANVAS START -->
                <b-col class="text-center" v-if="newsForm.show_popup">
                  <center>
                    <div class="mobile-popup-canvas">
                      <b-container>
                        <b-row>
                          <b-col>
                            <div
                              v-if="popupForm.type === 'poster'"
                              class="background-display"
                            >
                              <b-container>
                                <b-row>
                                  <b-col>
                                    <div class="popup-container">
                                      <span
                                        class="guide-letter"
                                        v-show="showGuides"
                                        style="
                                          position: absolute;
                                          left: 0px;
                                          top: -8px;
                                        "
                                      >
                                        C
                                      </span>
                                      <img
                                        src="@/assets/images/icons/close-circle.png"
                                        style="
                                          position: absolute;
                                          right: -5px;
                                          top: -38px;
                                        "
                                      />
                                      <div class="popup-poster-placeholder">
                                        <b-img
                                          v-if="popupPoster"
                                          :src="popupPoster"
                                          fluid
                                        />
                                      </div>
                                      <div
                                        v-if="
                                          popupForm.show_button &&
                                          popupForm.buttons.length
                                        "
                                        class="mt-3 w-100"
                                      >
                                        <button
                                          class="btn btn-pill mb-2 w-100"
                                          v-for="(
                                            button, index
                                          ) in popupForm.buttons"
                                          :key="index"
                                          :style="`background-color: ${popupForm.buttons[0].color}; color: ${popupForm.buttons[0].text_color}`"
                                        >
                                          {{ button.name }}
                                        </button>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-container>
                            </div>
                            <div
                              v-if="popupForm.type === 'banner'"
                              class="background-display"
                            >
                              <b-container>
                                <b-row>
                                  <b-col>
                                    <div class="popup-container">
                                      <span
                                        class="guide-letter"
                                        v-show="showGuides"
                                        style="
                                          position: absolute;
                                          left: 0px;
                                          top: -8px;
                                        "
                                      >
                                        C
                                      </span>
                                      <img
                                        src="@/assets/images/icons/close-circle.png"
                                        style="
                                          position: absolute;
                                          right: -5px;
                                          top: -38px;
                                        "
                                      />
                                      <div class="popup-banner-placeholder">
                                        <b-img
                                          v-if="popupBanner"
                                          :src="popupBanner"
                                          fluid
                                        />
                                      </div>
                                      <div
                                        v-if="
                                          popupForm.show_button &&
                                          popupForm.buttons.length
                                        "
                                        class="mt-3 w-100"
                                      >
                                        <button
                                          class="btn btn-pill mb-2 w-100"
                                          v-for="(
                                            button, index
                                          ) in popupForm.buttons"
                                          :key="index"
                                          :style="`background-color: ${popupForm.buttons[0].color}; color: ${popupForm.buttons[0].text_color}`"
                                        >
                                          {{ button.name }}
                                        </button>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-container>
                            </div>
                          </b-col>
                        </b-row>
                      </b-container>
                    </div>
                  </center>
                </b-col>
                <!-- MOBILE POPUP CANVAS END -->
              </b-row>
              <!-- MOBILE CANVAS END -->
            </b-col>
          </b-row>
          <!-- CANVAS END -->
        </b-col>
        <!-- DESIGN PREVIEW END -->
        <!-- DESIGN FORM START -->
        <b-col id="design-form" lg="4">
          <b-row class="mb-3">
            <b-col cols="11" xl="10" class="mx-auto">
              <div class="header-label">News</div>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="11" xl="10" class="mx-auto">
              <b-form-group label-for="input-news-title">
                <div slot="label">Title</div>
                <b-input
                  id="input-news-title"
                  v-model="newsForm.title"
                  placeholder="Enter Title"
                  :class="{ 'border-danger': !!newsErrors.title }"
                  :maxlength="titleCharLimit"
                ></b-input>
                <b-form-invalid-feedback :force-show="!!newsErrors.title">
                  {{ newsErrors.title }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="11" xl="10" class="mx-auto">
              <div role="group" class="secondary-label b-form-group form-group">
                <div class="image-upload-container mb-2">
                  <i class="guide-letter float-left">A</i>
                  <label class="primary-label pt-0">Image</label>
                </div>
                <img
                  v-if="newsImage"
                  src="@/assets/images/icons/remove.svg"
                  style="position: absolute; left: 255px; top: 25px; z-index: 1;"
                  @click="
                    $root.$emit('bv::show::modal', 'delete-news-image-modal')
                  "
                />
                <div
                  class="news-image-placeholder"
                  :class="{ 'border-danger': !!newsErrors.newsImage }"
                  @click="
                    $root.$emit('bv::show::modal', 'upload-news-image-modal')
                  "
                >
                  <div v-if="newsImage">
                    <b-img :src="newsImage" fluid />
                  </div>
                  <span class="camera-icon-container bg-white mr-1 mb-1">
                    <img src="@/assets/images/camera.svg" />
                  </span>
                </div>
                <em class="image-size">Recommended Size (375 x 300 px)</em>
              </div>
              <b-form-invalid-feedback :force-show="!!newsErrors.newsImage">
                {{ newsErrors.newsImage }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="11" xl="10" class="mx-auto">
              <b-form-group label-for="input-content">
                <div slot="label">
                  <i class="guide-letter float-left">B</i>
                  <label class="primary-label pt-0">Content</label>
                </div>
                <vue-editor
                  id="input-content"
                  ref="newsContentEditor"
                  v-model="newsForm.content"
                  :editorToolbar="editorToolbar"
                  :class="{ 'border border-danger': !!newsErrors.content }"
                  @text-change="onNewsContentChange"
                ></vue-editor>
              </b-form-group>
              <small class="text-muted">
                ({{ newsContentCharCount }} / 2000)
              </small>
              <b-form-invalid-feedback :force-show="!!newsErrors.content">
                {{ newsErrors.content }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="11" xl="10" class="mx-auto">
              <b-row class="mb-4">
                <b-col>
                  <b-row>
                    <b-col>
                      <div class="primary-label">Button (Optional)</div>
                    </b-col>
                    <b-col class="text-right">
                      <switches
                        v-model="newsForm.show_button"
                        theme="custom"
                        color="primary"
                      ></switches>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div v-if="newsForm.show_button && newsForm.buttons.length > 0" class="mb-3">
                <b-row class="mb-3">
                  <b-col>
                    <b-form-group
                      label="Button Color"
                      label-for="button-color"
                      class="primary-label"
                      required
                    >
                      <input
                        id="button-color"
                        type="color"
                        class="color-picker"
                        v-model="newsForm.buttons[0].color"
                      />
                      <img
                        class="color-picker-icon"
                        src="@/assets/images/icons/colorpicker.svg"
                      />
                    </b-form-group>
                    <span class="hex-color-label">{{
                      newsForm.buttons[0].color
                    }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <b-col>
                    <b-form-group label="Button Text" class="primary-label">
                      <b-form-radio-group
                        v-model="newsForm.buttons[0].text_color"
                      >
                        <b-form-radio value="#000000"
                          ><span
                            class="btn-text text-dark"
                            :style="`background-color: ${newsForm.buttons[0].color}`"
                            >Aa</span
                          ></b-form-radio
                        >
                        <b-form-radio value="#FFFFFF"
                          ><span
                            class="btn-text text-white"
                            :style="`background-color: ${newsForm.buttons[0].color}`"
                            >Aa</span
                          ></b-form-radio
                        >
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  class="mb-4"
                  :class="{
                    'border border-danger': !!newsErrors[`button${index}`],
                  }"
                  v-for="(button, index) in newsForm.buttons"
                  :key="index"
                >
                  <b-col>
                    <b-row class="border rounded-top">
                      <b-col cols="8" class="px-0">
                        <b-input
                          placeholder="Enter Button Label"
                          class="font-weight-bold form-control border-0"
                          v-model="button.name"
                        ></b-input>
                      </b-col>
                      <b-col
                        class="d-flex align-items-center justify-content-end"
                      >
                        <img
                          src="@/assets/images/actions/delete.svg"
                          alt="Delete"
                          class="cursor-pointer"
                          @click="newsForm.buttons.length > 1 ? deleteButton('news', index) : null"
                        />
                        <img
                          src="@/assets/images/dropdown.svg"
                          alt="Dropdown"
                          v-b-toggle="`news-button-config-collapse-${index}`"
                          class="cursor-pointer"
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-collapse
                        :id="`news-button-config-collapse-${index}`"
                        class="border w-100 bg-light rounded-bottom py-3"
                        visible
                      >
                        <b-container>
                          <b-row>
                            <b-col>
                              <b-select
                                :options="pageOptions"
                                v-model="button.redirect_to"
                              />
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-collapse>
                    </b-row>
                    <b-form-invalid-feedback
                      :force-show="!!newsErrors[`button${index}`]"
                      class="py-2"
                    >
                      {{ newsErrors[`button${index}`] }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button
                      variant="primary"
                      class="btn-add-outline"
                      @click="addButton('news')"
                      v-if="newsForm.buttons.length < 2"
                    >
                      Add Button
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="11" xl="10" class="mx-auto">
              <b-button
                variant="primary"
                class="btn-add-outline"
                @click="newsForm.show_popup = true"
                v-if="!newsForm.show_popup"
              >
                Create Pop up
              </b-button>
            </b-col>
          </b-row>
          <div v-if="newsForm.show_popup || ($route.params.uuid && popupDetails)">
            <b-row class="mb-3">
              <b-col cols="11" xl="10" class="mx-auto">
                <b-row>
                  <b-col>
                    <div class="header-label">Pop up</div>
                  </b-col>
                  <b-col
                    class="text-right cursor-pointer"
                    @click="newsForm.show_popup = false"
                  >
                    <span class="mr-1">Remove</span>
                    <img
                      src="@/assets/images/actions/delete.svg"
                      alt="Delete"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="11" xl="10" class="mx-auto">
                <b-form-group label-for="input-popup-title">
                  <div slot="label">Title</div>
                  <b-input
                    id="input-popup-title"
                    v-model="popupForm.title"
                    placeholder="Enter Title"
                    :class="{ 'border-danger': !!popupErrors.title }"
                    :maxlength="titleCharLimit"
                  ></b-input>
                  <b-form-invalid-feedback :force-show="!!popupErrors.title">
                    {{ popupErrors.title }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="11" xl="10" class="mx-auto">
                <div class="primary-label">Select Pop up Type</div>
                <b-form-radio-group
                  v-model="popupForm.type"
                  :options="popupTypeOptions"
                  class="mt-2"
                >
                </b-form-radio-group>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col
                cols="11" xl="10"
                class="mx-auto"
                v-if="popupForm.type === 'poster'"
              >
                <div
                  role="group"
                  class="secondary-label b-form-group form-group"
                >
                  <div class="image-upload-container mb-2">
                    <i class="guide-letter float-left">C</i>
                    <label class="primary-label pt-0">Image</label>
                  </div>
                  <img
                    v-if="popupPoster"
                    src="@/assets/images/icons/remove.svg"
                    style="position: absolute; left: 215px; top: 25px; z-index: 1;"
                    @click="
                      $root.$emit(
                        'bv::show::modal',
                        'delete-popup-poster-modal'
                      )
                    "
                  />
                  <div
                    class="popup-poster-placeholder"
                    :class="{ 'border-danger': !!popupErrors.popupPoster }"
                    @click="
                      $root.$emit(
                        'bv::show::modal',
                        'upload-popup-poster-modal'
                      )
                    "
                  >
                    <div v-if="popupPoster">
                      <b-img :src="popupPoster" fluid />
                    </div>
                    <span class="camera-icon-container bg-white mr-1 mb-1">
                      <img src="@/assets/images/camera.svg" />
                    </span>
                  </div>
                  <em class="image-size">Recommended Size (325 x 510 px)</em>
                </div>
                <b-form-invalid-feedback
                  :force-show="!!popupErrors.popupPoster"
                >
                  {{ popupErrors.popupPoster }}
                </b-form-invalid-feedback>
              </b-col>
              <b-col
                cols="11" xl="10"
                class="mx-auto"
                v-if="popupForm.type === 'banner'"
              >
                <div
                  role="group"
                  class="secondary-label b-form-group form-group"
                >
                  <div class="image-upload-container mb-2">
                    <i class="guide-letter float-left">C</i>
                    <label class="primary-label pt-0">Image</label>
                  </div>
                  <img
                    v-if="popupBanner"
                    src="@/assets/images/icons/remove.svg"
                    style="position: absolute; left: 215px; top: 25px; z-index: 1;"
                    @click="
                      $root.$emit(
                        'bv::show::modal',
                        'delete-popup-banner-modal'
                      )
                    "
                  />
                  <div
                    class="popup-banner-placeholder"
                    :class="{ 'border-danger': !!popupErrors.popupBanner }"
                    @click="
                      $root.$emit(
                        'bv::show::modal',
                        'upload-popup-banner-modal'
                      )
                    "
                  >
                    <div v-if="popupBanner">
                      <b-img :src="popupBanner" fluid />
                    </div>
                    <span class="camera-icon-container">
                      <img src="@/assets/images/camera.svg" />
                    </span>
                  </div>
                  <em class="image-size">Recommended Size (325 x 215 px)</em>
                </div>
                <b-form-invalid-feedback
                  :force-show="!!popupErrors.popupBanner"
                >
                  {{ popupErrors.popupBanner }}
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="11" xl="10" class="mx-auto">
                <div class="primary-label">Image Link</div>
                <b-form-radio-group
                  v-model="popupForm.link_type"
                  :options="popupImageLinkOptions"
                  class="mt-2"
                >
                </b-form-radio-group>
              </b-col>
            </b-row>
            <b-row class="mb-5" v-if="popupForm.link_type === 'external'">
              <b-col cols="10" class="mx-auto">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <img src="@/assets/images/icons/link.png" />
                  </b-input-group-prepend>
                  <b-form-input
                    placeholder="https://example.com"
                    v-model="popupForm.link"
                    :class="{ 'border-danger': !!popupErrors.link }"
                  ></b-form-input>
                  <b-form-invalid-feedback :force-show="!!popupErrors.link">
                    {{ popupErrors.link }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col cols="11" xl="10" class="mx-auto">
                <b-row class="mb-4">
                  <b-col>
                    <b-row>
                      <b-col>
                        <div class="primary-label">Button (Optional)</div>
                      </b-col>
                      <b-col class="text-right">
                        <switches
                          v-model="popupForm.show_button"
                          theme="custom"
                          color="primary"
                        ></switches>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <div v-if="popupForm.show_button" class="mb-3">
                  <b-row class="mb-3">
                    <b-col>
                      <b-form-group
                        label="Button Color"
                        label-for="button-color"
                        class="primary-label"
                        required
                      >
                        <input
                          id="button-color"
                          type="color"
                          class="color-picker"
                          v-model="popupForm.buttons[0].color"
                        />
                        <img
                          class="color-picker-icon"
                          src="@/assets/images/icons/colorpicker.svg"
                        />
                      </b-form-group>
                      <span class="hex-color-label">{{
                        popupForm.buttons[0].color
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mb-4">
                    <b-col>
                      <b-form-group label="Button Text" class="primary-label">
                        <b-form-radio-group
                          v-model="popupForm.buttons[0].text_color"
                        >
                          <b-form-radio value="#000000"
                            ><span
                              class="btn-text text-dark"
                              :style="`background-color: ${popupForm.buttons[0].color}`"
                              >Aa</span
                            ></b-form-radio
                          >
                          <b-form-radio value="#FFFFFF"
                            ><span
                              class="btn-text text-white"
                              :style="`background-color: ${popupForm.buttons[0].color}`"
                              >Aa</span
                            ></b-form-radio
                          >
                        </b-form-radio-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mb-4"
                    :class="{
                      'border border-danger': !!popupErrors[`button${index}`],
                    }"
                    v-for="(button, index) in popupForm.buttons"
                    :key="index"
                  >
                    <b-col>
                      <b-row class="border rounded-top">
                        <b-col cols="8" class="px-0">
                          <b-input
                            placeholder="Enter Button Label"
                            class="font-weight-bold form-control border-0"
                            v-model="button.name"
                          ></b-input>
                        </b-col>
                        <b-col
                          class="d-flex align-items-center justify-content-end"
                        >
                          <img
                            src="@/assets/images/actions/delete.svg"
                            alt="Delete"
                            class="cursor-pointer"
                            @click="deleteButton('popup', index)"
                          />
                          <img
                            src="@/assets/images/dropdown.svg"
                            alt="Dropdown"
                            v-b-toggle="`popup-button-config-collapse-${index}`"
                            class="cursor-pointer"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-collapse
                          :id="`popup-button-config-collapse-${index}`"
                          class="border w-100 bg-light rounded-bottom py-3"
                          visible
                        >
                          <b-container>
                            <b-row>
                              <b-col>
                                <b-select
                                  :options="pageOptions"
                                  v-model="button.redirect_to"
                                />
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-collapse>
                      </b-row>
                      <b-form-invalid-feedback
                        :force-show="!!popupErrors[`button${index}`]"
                        class="py-2"
                      >
                        {{ popupErrors[`button${index}`] }}
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button
                        variant="primary"
                        class="btn-add-outline"
                        @click="addButton('popup')"
                        v-if="popupForm.buttons.length < 2"
                      >
                        Add Button
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-row class="mt-5 mb-4">
            <b-col cols="11" xl="10" class="mx-auto">
              <div class="header-label">Publish Details</div>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="11" xl="10" class="mx-auto">
              <b-row class="mb-3">
                <b-col>
                  <div class="primary-label">Visibility</div>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>Web</b-col>
                <b-col class="text-right">
                  <switches
                    v-model="newsForm.web"
                    theme="custom"
                    color="primary"
                  ></switches>
                </b-col>
              </b-row>
              <b-row class="mb-2"> 
                <b-col>Mobile</b-col>
                <b-col class="text-right">
                  <switches
                    v-model="newsForm.mobile"
                    theme="custom"
                    color="primary"
                  ></switches>
                </b-col>
              </b-row>
              <b-row>
                <b-col>GLife <small>(Coming Soon)</small></b-col>
                <b-col class="text-right">
                  <switches
                    v-model="newsForm.glife"
                    theme="custom"
                    color="primary"
                    disabled
                  ></switches>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="11" xl="10" class="mx-auto">
              <div class="mb-2">
                Publish Date
                <i class="ic-tooltip" id="publish-date-tooltip"></i>
                <b-popover
                  target="publish-date-tooltip"
                  triggers="hover"
                  position="top"
                  content="Publish Date"
                >
                </b-popover>
              </div>
              <div class="customers-wrapper" style="min-height: initial;">
                <b-input-group>
                  <b-input-group slot="append">
                    <i class="icon-calendar"></i>
                  </b-input-group>
                  <datepicker
                    v-model="newsForm.published_date"
                    :config="publishDateConfig"
                  >
                  </datepicker>
                </b-input-group>
              </div>
              <b-form-invalid-feedback
                :force-show="!!newsErrors['published_date']"
                class="py-2"
              >
                {{ newsErrors['published_date'] }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-col>
        <!-- DESIGN FORM END -->
      </b-row>
      <!-- MODALS START -->
      <UploadNewsImageModal />
      <UploadPopupPosterModal />
      <UploadPopupBannerModal />
      <DeleteNewsImageModal />
      <DeletePopupPosterModal />
      <DeletePopupBannerModal />
      <SaveNewsModal :publishNews="publishNews" />
      <!-- MODALS END -->
    </b-container>
  </div>
</template>

<script>
import UploadNewsImageModal from "./modals/UploadNewsImageModal";
import UploadPopupPosterModal from "./modals/UploadPopupPosterModal";
import UploadPopupBannerModal from "./modals/UploadPopupBannerModal";
import DeleteNewsImageModal from "./modals/DeleteNewsImageModal";
import DeletePopupPosterModal from "./modals/DeletePopupPosterModal";
import DeletePopupBannerModal from "./modals/DeletePopupBannerModal";
import SaveNewsModal from "./modals/SaveNewsModal";
import moment from "moment";
import Switches from "vue-switches";
import notification from "@/services/notification";
import Datepicker from "vue-bulma-datepicker";
import { VueEditor } from "vue2-editor";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

const dateToday = moment().format("YYYY-MM-DD");

export default {
  name: "NewsDesignPage",
  data() {
    return {
      titleCharLimit: 30,
      newsContentCharLimit: 2000,
      showGuides: true,
      popupTypeOptions: [
        { value: "poster", text: "Poster" },
        { value: "banner", text: "Banner" },
      ],
      popupImageLinkOptions: [
        { value: "external", text: "External Link" },
        { value: "news", text: "News Link" },
      ],
      pageOptions: [
        { value: "null", text: "Select Page", disabled: true },
        { value: "home", text: "Home" },
        { value: "privilege_card", text: "Privilege Card" },
      ],
      publishDateConfig: {
        altInput: true,
        altFormat: "m/d/Y",
        dateFormat: "Y-m-d",
        default: ["today"],
        static: true
      },
      editorToolbar: [
        [{ size: [] }],
        [{ color: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ align: ["", "center", "right", "justify"] }],
      ],
      newsErrors: {},
      popupErrors: {},
      link: "",
      newsForm: null,
      popupForm: null,
      storedNewsImage: null,
      storedPopupImage: null
    };
  },
  props: ["uuid"],
  components: {
    Switches,
    Datepicker,
    VueEditor,
    UploadNewsImageModal,
    UploadPopupPosterModal,
    UploadPopupBannerModal,
    DeleteNewsImageModal,
    DeletePopupPosterModal,
    DeletePopupBannerModal,
    SaveNewsModal,
  },
  methods: {
    ...mapMutations("engagementNews", ["setNewsImage"]),
    ...mapMutations("designs", ["setActiveListType"]),
    ...mapMutations("engagementPopup", ["setPopupPoster", "setPopupBanner", "setPopupDetails"]),
    ...mapActions("engagementNews", ["getNewsDetails", "createNews", "updateNews"]),
    ...mapActions("engagementPopup", ["createPopup", "updatePopup"]),
    onNewsContentChange() {
      if (this.newsContentCharCount > this.newsContentCharLimit)
        this.$refs.newsContentEditor.quill.deleteText(
          this.newsContentCharLimit,
          this.newsContentCharCount
        );
    },
    isImageUrl(item) {
      return item.includes("data:image");
    },
    isUrlLink(text) {
      return /^(https:|http:|www\.)\S*/.test(text);
    },
    addButton(type) {
      this[`${type}Form`].buttons.push({
        name: "View Products",
        color: "#FF8828",
        text_color: "#FFFFFF",
        redirect_to: "products",
      });
    },
    deleteButton(type, index) {
      if (!this[`${type}Form`].buttons.length) return;

      this[`${type}Form`].buttons.splice(index, 1);
    },
    async saveNews(_, isDraft = true) {
      const newsErrors = {};
      const popupErrors = {};
      const popupImageType = `popup${this.popupForm.type[0].toUpperCase()}${this.popupForm.type.slice(
        1
      )}`;

      if (!this.newsForm.title) newsErrors.title = "Title is required";

      if (!this.newsImage) newsErrors.newsImage = "Image is required";

      if (!this.newsForm.content) newsErrors.content = "Content is required";

      if (this.newsContentCharCount > this.newsContentCharLimit)
        newsErrors.content = "Up to 2000 characters only";

      if (this.newsForm.show_button)
        this.newsForm.buttons.map((button, index) => {
          this.newsForm.buttons[index].color = this.newsForm.buttons[0].color; // always set button color to the color of the 1st item in the buttons array
          this.newsForm.buttons[index].text_color = this.newsForm.buttons[0].text_color; // always set button text_color to the color of the 1st item in the buttons array
          if (!button.name)
            newsErrors[`button${index}`] = "Button Label is required";
        });

      if (this.newsForm.show_popup) {
        if (!this.popupForm.title) popupErrors.title = "Title is required";

        if (!this[popupImageType])
          popupErrors[popupImageType] = "Image is required";

        if (this.popupForm.link_type === "external") {
          if (!this.popupForm.link) popupErrors.link = "Link is required";

          if (this.popupForm.link && !this.isUrlLink(this.popupForm.link))
            popupErrors.link = "Must be a valid url link";
        }

        if (this.popupForm.show_button)
          this.popupForm.buttons.map((button, index) => {
            this.popupForm.buttons[index].color = this.popupForm.buttons[0].color; // always set button color to the color of the 1st item in the buttons array
            this.popupForm.buttons[index].text_color = this.popupForm.buttons[0].text_color; // always set button text_color to the color of the 1st item in the
            if (!button.name)
              popupErrors[`button${index}`] = "Button Label is required";
          });
        
        this.popupForm.is_draft = isDraft;
        this.popupForm.mobile = this.newsForm.mobile;
        this.popupForm.web = this.newsForm.web;
      }

      if (this.newsForm.published_date < dateToday)
        newsErrors["published_date"] = "Published date cannot be a previous date.";

      this.newsErrors = newsErrors;
      this.popupErrors = popupErrors;

      if (Object.keys(newsErrors).length || Object.keys(popupErrors).length) {
        notification.warning(`Oops, cannot ${!this.$route.params.uuid ? 'create' : 'update'} news.`);

        return;
      }

      if (this.isImageUrl(this.newsImage))
        this.newsForm.image = this.newsImage.split(",").pop();
      
      this.newsForm.is_draft = isDraft;

      if (!this.$route.params.uuid) {
        await this.createNews(this.newsForm).then(async () => {
          if (this.newsForm.show_popup) {
            this.popupForm.news_uuid = this.newsDetails.uuid;
            if (this.popupForm.link_type === "news" && this.newsDetails) {
              this.popupForm.link = "";
            }

            if (this.isImageUrl(this[popupImageType]))
              this.popupForm.image = this[popupImageType].split(",").pop();

            await this.createPopup(this.popupForm);
          }
        });
      } else {
        if (this.storedNewsImage === this.newsImage)
          delete this.newsForm.image; // remove image from params if unchanged

        await this.updateNews(this.newsForm).then(async () => {
          if (this.newsForm.show_popup) {
            this.popupForm.news_uuid = this.newsDetails.uuid;
            if (this.popupForm.link_type === "news" && this.newsDetails) {
              this.popupForm.link = "";
            }

            if (this.isImageUrl(this[popupImageType]))
              this.popupForm.image = this[popupImageType].split(",").pop();

            if (!this.popupDetails) {
              await this.createPopup(this.popupForm);
            } else {
              if (this.storedPopupImage === (this.popupForm.type === "poster" ? this.popupPoster : this.popupBanner))
                delete this.popupForm.image; // remove image from params if unchanged

              if (this.popupForm.link_type === "news" && this.newsDetails) {
                this.popupForm.link = "";
                this.popupForm.news_uuid = this.newsDetails.uuid;
              }

              if (this.isImageUrl(this[popupImageType]))
              this.popupForm.image = this[popupImageType].split(",").pop();
              await this.updatePopup(this.popupForm);
            }
          }
        });
      }

      if (isDraft) {
        this.$router.push({ name: "engagementNewsPopUp" });
        this.setActiveListType("drafts");
      }
    },
    async publishNews() {
      this.newsForm.is_draft = false;
      this.popupForm.is_draft = false;
      await this.saveNews(_, false);
      this.newsForm.is_draft = true;
      this.popupForm.is_draft = true;

      if (
        Object.keys(this.newsErrors).length ||
        Object.keys(this.popupErrors).length ||
        !this.newsDetails ||
        (this.newsForm.show_popup && !this.popupDetails)
      )
        return false;

      return true;
    },
  },
  computed: {
    ...mapState("engagementNews", {
      isNewsLoading: (state) => state.isLoading,
      newsDetails: (state) => state.newsDetails,
      newsImage: (state) => state.newsImage,
    }),
    ...mapState("engagementPopup", {
      isPopupLoading: (state) => state.isLoading,
      popupDetails: (state) => state.popupDetails,
      popupPoster: (state) => state.popupPoster,
      popupBanner: (state) => state.popupBanner,
    }),
    ...mapGetters({
      newsDetails: "engagementNews/newsDetails"
    }),
    newsContentCharCount() {
      return this.newsForm.content.replace(/<[^>]*>?/gm, "").trim().length;
    },
    isLoading() {
      return this.isNewsLoading || this.isPopupLoading;
    },
  },
  async created() {
    this.newsForm = {
      title: "",
      content: "",
      image: "",
      web: false,
      mobile: false,
      glife: false,
      published_date: dateToday,
      is_draft: true,
      show_button: false,
      buttons: [
        {
          name: "View Products",
          color: "#FF8828",
          text_color: "#FFFFFF",
          redirect_to: "products",
        },
      ],
      show_popup: false,
    };

    this.popupForm = {
      title: "",
      type: "poster",
      image: "",
      web: false,
      mobile: false,
      link_type: "external",
      link: "",
      published_date: dateToday,
      is_draft: true,
      show_button: false,
      buttons: [
        {
          name: "View Products",
          color: "#FF8828",
          text_color: "#FFFFFF",
          redirect_to: "products",
        },
      ],
    };

    this.newsErrors = {};
    this.popupErrors = {};
    this.setNewsImage(null);
    this.setPopupPoster(null);
    this.setPopupBanner(null);

    if (this.$route.params.uuid)
      await this.getNewsDetails(this.$route.params.uuid)
        .then(() => {
          this.newsForm = this.newsDetails;
          this.storedNewsImage = this.newsImage;
          this.storedPopupImage = this.popupDetails && this.popupDetails.type === "poster" ? this.popupPoster : this.popupBanner;
          if (this.newsDetails.show_popup)
            this.popupForm = this.popupDetails;
        });
  },
  beforeDestroy() {
    this.setPopupDetails(null);
  }
};
</script>

<style lang="scss">
</style>
